
<app-radio-input-group #childDiagnosisComponent [indication]="indication" [labelName]="'Diagnosis'" [controlName]="'diagnosis'" 
 [controlDisplayName]="'Diagnosis'" [hasCustomControlParent]="true" (indicationSelectionChanged)="childSharedControlSelectionChangedHandler($event)"></app-radio-input-group>
<br />
<div class="criteria-section" *ngIf="showCriteriaSection()">
  <kendo-label
    [text]="'CKD criteria'"
    class="input-label-header"
  ></kendo-label>
  <hr class="input-label-header-hr" />
</div>
<form [formGroup]="formGroup" [hidden]="!showCriteriaSection()">
  <!-- radio button section for equation to use -->
  <div class="row mb-3 mt-3">
    <div class="col-sm-3 form-check">
      <label style="font-size: 15px;">GFR Equation:</label>
    </div>
    <div class="col-sm-9 radio-wrapper">
      <div class="form-check white-inputs" *ngFor="let inputOption of equationRadioInputOptions">
        <kendo-label
          class="form-check-label"
          [for]="radioOption"
          [text]="inputOption.displayName"
        ></kendo-label>
        <input
          class="form-check-input"
          type="radio"
          name="{{equationVariableName}}"
          #radioOption
          [value]="inputOption.name"
          formControlName="{{equationVariableName}}"
          kendoRadioButton
          (change)="updateSelections()"
        />
      </div>
    </div>
  </div>
  <!-- lower and upper limits input section -->
  <div class="row">
    <div class="col-2"></div>
    <div class="col-5" style="text-align: center;">
      <kendo-label text="Lower Limits (>=)"></kendo-label>
    </div>
    <div class="col-5" style="text-align: center;">
      <kendo-label text="Upper Limits (<)"></kendo-label>
    </div>
  </div>
  <div class="form-check" *ngFor="let inputOption of ckdCriteriaOptions">
    <div class="row" style="margin-bottom: 2em;">
      <div class="col-2 mb-1">
        <kendo-label class="k-form limits-labels" [text]="inputOption.lowerLimits.name.split('_')[0].toString()" style="color: #92929f;"></kendo-label>
        <kendo-label class="k-form" [text]="'(' + inputOption.lowerLimits.measurement + ')'" style="color: #92929f; font-size: 12px;"></kendo-label>
      </div>
      <div class="col-5 mb-1">
        <kendo-textbox
            [formControlName]="inputOption.lowerLimits.name"
            placeholder=""
            [clearButton]="true"
            (valueChange)="updateSelections()"
            [maxlength]="5"
            [minlength]="1"
          >
          </kendo-textbox>
      </div>
      <div class="col-5 mb-1">
        <kendo-textbox
            [formControlName]="inputOption.upperLimits.name"
            placeholder=""
            [clearButton]="true"
            (valueChange)="updateSelections()"
            [maxlength]="5"
            [minlength]="1"
          >
          </kendo-textbox>
      </div>
    </div>
  </div>
  <!-- radio button section for equation to use -->
  <div class="row mb-3 mt-3">
    <div class="col-sm-4 form-check">
      <label style="font-size: 15px;">Include Hemoglobin Limits:</label>
    </div>
    <div class="col-sm-8 radio-wrapper">
      <div class="form-check white-inputs" *ngFor="let inputOption of includeHemoglobinRadioInputOptions">
        <kendo-label
          class="form-check-label"
          [for]="radioOption"
          [text]="inputOption.displayName"
        ></kendo-label>
        <input
          class="form-check-input"
          type="radio"
          name="{{includeHemoglobinLimitsVariableName}}"
          #radioOption
          [value]="inputOption.name"
          formControlName="{{includeHemoglobinLimitsVariableName}}"
          kendoRadioButton
          (change)="updateSelections()"
        />
      </div>
    </div>
  </div>
  <app-limits-input [controlName]="'hemoglobinLimits'" *ngIf="showHemoglobinLimitsSection()" #childLimitsComponent [indication]="ckdHemoglobinLimitsIndication" [hasCustomControlParent]="true" (indicationSelectionChanged)="childSharedTextControlSelectionChangedHandler($event)"></app-limits-input>
</form>
<br />
<button kendoButton (click)="setDefaults()">Set Default Values</button>
